import {
    CONFIDENCE_LEVELS_PARAM,
    FLAGGED_FOR_MYSELF_PARAM,
    ASSIGNEE_IDS_PARAM,
    FLAGGED_PARAM,
    MISMATCH_PARAM,
    REVIEW_STATUS_PARAM,
} from './query-params'

export const FilterParamNames = [
    MISMATCH_PARAM,
    FLAGGED_PARAM,
    REVIEW_STATUS_PARAM,
    CONFIDENCE_LEVELS_PARAM,
    FLAGGED_FOR_MYSELF_PARAM,
    ASSIGNEE_IDS_PARAM,
]

export const FilterParamDefaultValue = {
    [MISMATCH_PARAM]: 'false',
    [FLAGGED_PARAM]: 'false',
    [FLAGGED_FOR_MYSELF_PARAM]: 'false',
    [REVIEW_STATUS_PARAM]: 'any',
    [CONFIDENCE_LEVELS_PARAM]: null,
}
